export default __webpack_public_path__ + "static/media/icon-task-erm.9e2f1a33.svg";